var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackRankingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80444 19.0792C6.80444 17.882 6.80444 17.2834 7.17636 16.9114C7.54829 16.5396 8.14689 16.5396 9.34408 16.5396H9.76735C10.5655 16.5396 10.9645 16.5396 11.2125 16.7875C11.4604 17.0355 11.4604 17.4345 11.4604 18.2326V22.4654H6.80444V19.0792Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5396 19.9258C16.5396 19.1276 16.5396 18.7286 16.7875 18.4806C17.0355 18.2327 17.4345 18.2327 18.2326 18.2327H18.6559C19.8531 18.2327 20.4517 18.2327 20.8237 18.6046C21.1956 18.9765 21.1956 19.5751 21.1956 20.7723V22.4654H16.5396V19.9258Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53467 22.4656H22.4656",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4604 17.3861C11.4604 16.1889 11.4604 15.5903 11.8324 15.2183C12.2043 14.8464 12.8029 14.8464 14.0001 14.8464C15.1973 14.8464 15.7959 14.8464 16.1678 15.2183C16.5397 15.5903 16.5397 16.1889 16.5397 17.3861V22.4653H11.4604V17.3861Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.585 6.02369L15.1809 7.22535C15.2622 7.39263 15.4788 7.55307 15.6616 7.58379L16.7417 7.76472C17.4324 7.88079 17.595 8.38604 17.0972 8.88445L16.2575 9.73107C16.1154 9.87445 16.0375 10.151 16.0815 10.349L16.3219 11.397C16.5115 12.2265 16.0747 12.5475 15.3468 12.1139L14.3344 11.5097C14.1516 11.4004 13.8503 11.4004 13.664 11.5097L12.6517 12.1139C11.9271 12.5475 11.4869 12.2231 11.6765 11.397L11.9169 10.349C11.961 10.151 11.8831 9.87445 11.7409 9.73107L10.9012 8.88445C10.4069 8.38604 10.566 7.88079 11.2567 7.76472L12.3367 7.58379C12.5162 7.55307 12.7329 7.39263 12.8142 7.22535L13.4101 6.02369C13.7352 5.37166 14.2633 5.37166 14.585 6.02369Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackRankingIcon);
export default __webpack_public_path__ + "static/media/black_ranking_icon.435ae08f1dff3e538182dc47ef83ff60.svg";
export { ForwardRef as ReactComponent };